import * as React from 'react';
import { KansatsuKiroku } from '../models/KansatsuKiroku';
import { SiteInfo } from '../models/SiteInfo';
import * as moment from 'moment';
import { InferenceResultView } from './parts/InferenceResultView';
import KansatsuKirokuEdit from './parts/KansatsuKirokuEdit';

interface OwnProps {
  siteInfo: SiteInfo;
  kansatsuKiroku: KansatsuKiroku;
};
/**
 * 観察記録印刷用コンポーネント
 */
export const PrintKansatsuKiroku: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <div
      style={{
        margin: '50px'
      }}
    >
      {/* ヘッダ部分 */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div
          style={{
            display: 'flex',
            fontSize: '120%'
          }}
        >
          {props.siteInfo.koujiBangou} : {props.siteInfo.name}
        </div>
        <div
          style={{
            display: 'flex',
            fontSize: '80%'
          }}
        >
          作成 {props.kansatsuKiroku.createdAt ? moment(props.kansatsuKiroku.createdAt).format('MM/DD HH:mm') : '-'}<br/>
          更新 {props.kansatsuKiroku.lastModifiedAt ? moment(props.kansatsuKiroku.lastModifiedAt).format('MM/DD HH:mm') : '-'}
        </div>
      </div>

      {/* 印刷本体 */}
      <div
        style={{
          width: '100%',
          display: 'flex'
        }}
      >
        {/* 2カラム表示にする */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '50%'
          }}
        >
          {/* 観察記録情報Box */}
          <div
            style={{
              display: 'flex',
              zoom: '50%'
            }}
          >
            <KansatsuKirokuEdit
              // 編集不可にするとテキストがグレー表示で見づらいので編集可能でボタンを非表示とする
              disabled={false}
              hideButtons={true}
              data={props.kansatsuKiroku}
            />
          </div>
          {/* 観察記録情報Boxここまで */}
          {/* 診断画像Box */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                marginBottom: '10px'
              }}
            >診断画像</div>
            <div>
              {
                (props.kansatsuKiroku.croppedImageSignedUrl)
                  ? <img
                      style={{ maxHeight: '300px', maxWidth: '500px' }}
                      src={props.kansatsuKiroku.croppedImageSignedUrl} />
                  : <div>診断画像なし</div>
              }
            </div>
          </div>
          {/* 診断画像Boxここまで */}        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* 診断結果Box */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              zoom: '50%'
            }}
          >
            <div
              style={{
                marginBottom: '10px'
              }}
            >診断結果</div>
            {
                props.kansatsuKiroku.inferenceResult
                ? <InferenceResultView
                    result={props.kansatsuKiroku.inferenceResult}
                    additionalResult={props.kansatsuKiroku.inferenceAdditionalResult}
                  />
                : <div>診断結果なし</div>
            }
          </div>
          {/* 診断結果Boxここまで　 */}
        </div>

      </div>
    </div>

  );
}



// WEBPACK FOOTER //
// ./src/components/PrintKansatsuKiroku.tsx